// Interactive Map javascript behaviors
import $ from 'jquery';

Drupal.behaviors.interactiveMap = {
  attach() {
    // Interactive map section.
    $(function() {
      /* Map plotting */
      $('.mapPoints ul li').click(function hasClass() {
        if ($(this).hasClass('sel')) {
          return false;
        }
        var plotIndex = $(this).index();
        var addressLeft = $(this).offset().left - parseFloat($('.mapAddress ul li').width()) / 2;
        var addressTop =
          $(this).offset().top -
          $('.innerPage').offset().top +
          5 -
          parseFloat($('.innerPage').css('paddingTop'));
        $(this)
          .addClass('sel')
          .siblings()
          .removeClass('sel');
        if (addressLeft + parseFloat($('.mapAddress ul li').width()) > $(window).width()) {
          addressLeft = addressLeft - parseFloat($('.mapAddress ul li').width()) / 2;
        }
        $('.mapAddress ul li')
          .eq(plotIndex)
          .css({ left: addressLeft, top: addressTop })
          .show()
          .siblings()
          .hide();
      });
      $('.map').click(function removeClass() {
        $('.mapPoints ul li').removeClass('sel');
        $('.mapAddress ul li').hide();
      });

      $('.mapAddress ul li h2')
        .click(function mapAddress() {
          if ($(window).width() < 768) {
            $(this)
              .addClass('active')
              .parent()
              .siblings()
              .find('h2')
              .removeClass('active');
            $(this)
              .siblings('.address')
              .slideDown(600)
              .parent()
              .siblings('li')
              .find('.address')
              .hide();
            var getpos = $(this).parent('li');
            setTimeout(function() {
              $('body,html').animate({ scrollTop: getpos.offset().top - 15 }, 500);
            }, 500);
          }
        })
        .eq(0)
        .click();

      $('.manu').click(function menu() {
        $(this).addClass('active');
        $('.rnd,.global').removeClass('active');
        $('.mapAddress ul li').hide();
        $('.mapPoints ul li').removeClass('sel');
        $(this)
          .parents('.mapContainer')
          .find('.mapPoints ul, .mapAddress ul')
          .removeAttr('class');
        $(this)
          .parents('.mapContainer')
          .find('.mapPoints ul, .mapAddress ul')
          .addClass('manufacture');
        $('.mapPoints li').hide();
        $(
          '.mapPoints li.plot2, .mapPoints li.plot1, .mapPoints li.plot20, .mapPoints li.plot13'
        ).show();
      });
      $('.rnd').click(function rnd() {
        $(this).addClass('active');
        $('.manu,.global').removeClass('active');
        $('.mapAddress ul li').hide();
        $('.mapPoints ul li').removeClass('sel');
        //$(this).parents('.mapContainer').addClass('rnd');
        $(this)
          .parents('.mapContainer')
          .find('.mapPoints ul, .mapAddress ul')
          .removeAttr('class');
        $(this)
          .parents('.mapContainer')
          .find('.mapPoints ul, .mapAddress ul')
          .addClass('research');
        $('.mapPoints li').hide();
        $(
          '.mapPoints li.plot1, .mapPoints li.plot7,.mapPoints li.plot20, .mapPoints li.plot24'
        ).show();
      });

      $('.global').click(function global() {
        $(this).addClass('active');
        $('.manu,.rnd').removeClass('active');
        $('.mapAddress ul li').hide();
        $('.mapPoints ul li').removeClass('sel');
        $(this)
          .parents('.mapContainer')
          .find('.mapPoints ul, .mapAddress ul')
          .removeAttr('class');
        $('.mapPoints li').show();
      });
    });

    $(window).on('load', function window() {
      mapPlot();
    });
    $(window).resize(function windowResize() {
      if (this.resizeTO) clearTimeout(this.resizeTO);
      this.resizeTO = setTimeout(function() {
        $(this).trigger('resizeEnd');
      }, 100);
    });
    var cachedWidth = $(window).width();

    $(window).bind('resizeEnd', function() {
      //alert(678)
      var newWidth = $(window).width();
      if (newWidth !== cachedWidth) {
        cachedWidth = newWidth;
      }

      heightCalc();
      mapPlot();
    });

    function mapPlot() {
      $('.mapPoints ul li').removeAttr('style');
      var plotLength = $('.mapPoints ul li').length;
      var mapWidth = parseFloat($('.map img').width());
      var mapHeight = parseFloat($('.map img').height());
      for (var i = 0; i < plotLength; i++) {
        var plotLeft = parseFloat(
          $('.mapPoints ul li')
            .eq(i)
            .css('left')
        );
        var plotTop = parseFloat(
          $('.mapPoints ul li')
            .eq(i)
            .css('top')
        );
        $('.mapPoints ul li')
          .eq(i)
          .css({
            left: (mapWidth / 932) * plotLeft,
            top: (mapHeight / 431) * plotTop,
          });
      }
    }

    function heightCalc() {
      var headerHeight = $('.top_header').outerHeight();
      var mainbanerH = widHeight - headerHeight;
      var finalheight = Math.floor((mainbanerH * 90) / 100);

      $('.top_banner,.top_banner .item img').css('height', finalheight);
    }

    var widHeight = $(window).outerHeight();
  },
};
